<template>
    <div class="student-pad-container">
        <!-- 头部标题 -->
        <div class="page-header">
            <img src="@/assets/images/studentPad/title_left.png" class="title-icon" />
            <span class="page-title">{{ schoolName }}学生机数据分析看板</span>
            <img src="@/assets/images/studentPad/title_right.png" class="title-icon" />
            <div class="tip-content">
                <i class="tip-icon"></i>
                <span>数据每日0点自动更新</span>
            </div>
        </div>

        <!-- 页面主体部分 -->
        <div class="student-pad-main">
            <!-- 总览数据 -->
            <div class="top-statistics">
                <div class="stat-card stat-card-blue">
                    <div class="stat-card-border"></div>
                    <div class="stat-card-content">
                        <div class="stat-info">
                            <div class="stat-label">应用使用总人数</div>
                            <div class="stat-value">{{ totalUsers | numberFormat }}</div>
                            <div class="stat-desc">占全校学生机开通人数<span class="stat-desc-val">{{ userPercentage }}</span></div>
                        </div>
                        <div class="stat-icon">
                            <img src="@/assets/images/studentPad/person_num.png" />
                        </div>
                    </div>
                </div>

                <div class="stat-card stat-card-green">
                    <div class="stat-card-border"></div>
                    <div class="stat-card-content">
                        <div class="stat-info">
                            <div class="stat-label">应用使用总次数</div>
                            <div class="stat-value">{{ totalUsages | numberFormat }}</div>
                        </div>
                        <div class="stat-icon">
                            <img src="@/assets/images/studentPad/total-num.png" />
                        </div>
                    </div>
                </div>

                <div class="stat-card stat-card-yellow">
                    <div class="stat-card-border"></div>
                    <div class="stat-card-content">
                        <div class="stat-info">
                            <div class="stat-label">昨日人均使用时长</div>
                            <div class="stat-value">{{ avgDuration }}分钟</div>
                        </div>
                        <div class="stat-icon">
                            <img src="@/assets/images/studentPad/time_num.png" />
                        </div>
                    </div>
                </div>
            </div>

            <!-- 应用使用情况和使用趋势 -->
            <div class="chart-row">
                <!-- Top10应用使用情况 -->
                <div class="chart-card chart-card-large">
                    <div class="chart-header">
                        <div class="chart-title">
                            <span class="title-bar"></span>
                            <span>TOP10应用使用情况</span>
                        </div>
                        <div class="chart-tabs">
                            <button :class="['tab-btn', { 'active': top10TabActive === 'times' }]"
                                @click="top10TabActive = 'times'">使用时长</button>
                            <button :class="['tab-btn', { 'active': top10TabActive === 'users' }]"
                                @click="top10TabActive = 'users'">使用人数</button>
                            <button :class="['tab-btn', { 'active': top10TabActive === 'nums' }]"
                                @click="top10TabActive = 'nums'">使用次数</button>
                        </div>
                    </div>
                    <div class="chart-content" ref="top10Chart" style="height: 380px;"></div>
                </div>

                <!-- 应用使用趋势 -->
                <div class="chart-card chart-card-large">
                    <div class="chart-header">
                        <div class="chart-title">
                            <span class="title-bar"></span>
                            <span>应用使用趋势</span>
                            <span class="sub-title">（近7天）</span>
                        </div>
                        <div class="chart-tabs">
                            <button :class="['tab-btn', { 'active': trendTabActive === 'times' }]"
                                @click="trendTabActive = 'times'">使用时长</button>
                            <button :class="['tab-btn', { 'active': trendTabActive === 'users' }]"
                                @click="trendTabActive = 'users'">使用人数</button>
                            <button :class="['tab-btn', { 'active': trendTabActive === 'nums' }]"
                                @click="trendTabActive = 'nums'">使用次数</button>
                        </div>
                    </div>
                    <div class="chart-content" ref="trendChart" style="height: 380px;"></div>
                </div>
            </div>

            <!-- 应用类型分布和应用使用明细 -->
            <div class="chart-row">
                <!-- 应用类型分布 -->
                <div class="chart-card chart-card-large"">
                    <div class=" chart-header">
                    <div class="chart-title">
                        <span class="title-bar"></span>
                        <span>应用类型分布</span>
                    </div>
                    <div class="chart-tabs">
                        <button :class="['tab-btn', { 'active': typeTabActive === 'times' }]"
                            @click="typeTabActive = 'times'">使用时长</button>
                        <button :class="['tab-btn', { 'active': typeTabActive === 'users' }]"
                            @click="typeTabActive = 'users'">使用人数</button>
                        <button :class="['tab-btn', { 'active': typeTabActive === 'nums' }]"
                            @click="typeTabActive = 'nums'">使用次数</button>
                    </div>
                </div>
                <div class="chart-content" ref="typeChart" style="height: 370px;"></div>
            </div>

            <!-- 应用使用明细 -->
            <div class="chart-card chart-card-large">
                <div class="chart-header">
                    <div class="chart-title">
                        <span class="title-bar"></span>
                        <span>应用使用明细</span>
                    </div>
                </div>
                <div class="table-content app-detail-table">
                    <Table :columns="appDetailColumns" :data="appDetailList" @on-sort-change="handleAppSort"></Table>
                </div>
            </div>
        </div>

        <!-- 班级使用明细 -->
        <div class="chart-row">
            <div class="chart-card chart-card-full">
                <div class="chart-header">
                    <div class="chart-title">
                        <span class="title-bar"></span>
                        <span>班级使用明细</span>
                    </div>
                </div>
                <div class="table-content">
                    <Table :columns="classDetailColumns" :data="currentClassList" @on-sort-change="handleClassSort">
                    </Table>

                    <!-- 分页 -->
                    <div class="bottom-page">
                        <div class="laypage_main">
                            <Page :total="pageParams.total" @on-change="handleCurrentChange" :current="pageParams.page"
                                v-if="pageParams.total && pageParams.pageCount > 1" show-total></Page>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    </div>
</template>

<script>
import echarts from 'echarts';
import { getSchoolStatistic, getAppUseTop, getAppUseTrend, getAppUseDistribution, getAppUseDetail, getClassUseList } from "@/service/studentPadApi"
import { formatSeconds, secondsToMinutes, secondsToHours } from "@/util/timeFormat"

export default {
    name: 'StudentPad',
    data() {
        return {
            totalUsers: 0,
            userPercentage: '0%',
            totalUsages: 0,
            avgDuration: 0,
            top10TabActive: 'times',
            trendTabActive: 'times',
            typeTabActive: 'times',
            top10ChartInstance: null,
            trendChartInstance: null,
            typeChartInstance: null,
            top10Data: null, // Top10应用使用数据
            trendData: null, // 应用使用趋势数据
            typeData: null, // 应用类型分布数据
            appDetailList: [],
            appDetailSort: {
                sort: 'useAvgTime', // 默认按人均使用时长排序
                order: 'desc' // 默认降序
            },
            classDetailList: [],
            classDetailSort: {
                sortType: 4, // 排序类型(1:使用人数 2:使用次数 3:使用时长 4:人均使用时长)
                order: 'desc' // 排序方式(asc:升序 desc:降序)
            },
            pageParams: {
                page: 1,
                limit: 10,
                total: 0,
                pageCount: 0
            },
            schoolId: this.$route.query.schoolId,
            schoolName: this.$route.query.schoolName,
            // 应用使用明细表格列配置
            appDetailColumns: [
                {
                    title: '排名',
                    width: 60,
                    align: 'center',
                    render: (h, params) => {
                        return h('span', params.index + 1);
                    }
                },
                {
                    title: '应用名称',
                    key: 'appName'
                },
                {
                    title: '应用类型',
                    key: 'appType',
                    render: (h, params) => {
                        const typeClass = this.getAppTypeClass(params.row.moduleCode);
                        return h('span', {
                            class: ['app-type-tag', typeClass]
                        }, params.row.appType);
                    }
                },
                {
                    title: '使用人数',
                    key: 'users',
                    align: 'center',
                   
                    sortable: 'custom'
                },
                {
                    title: '使用次数',
                    key: 'times',
                    align: 'center',
                    
                    sortable: 'custom'
                },
                {
                    title: '使用时长',
                    key: 'duration',
                    align: 'center',
                    
                    sortable: 'custom'
                },
                {
                    title: '人均使用时长',
                    key: 'avgDuration',
                    align: 'center',
                    width: 120,
                    sortable: 'custom',
                    sortType: 'desc'
                }
            ],
            // 班级使用明细表格列配置
            classDetailColumns: [
                {
                    title: '排名',
                    width: 80,
                    align: 'center',
                    render: (h, params) => {
                        return h('span', (this.pageParams.page - 1) * this.pageParams.limit + params.index + 1);
                    }
                },
                {
                    title: '班级',
                    key: 'className'
                },
                {
                    title: '使用人数',
                    key: 'userCount',
                    align: 'center',
                    sortable: 'custom'
                },
                {
                    title: '使用次数',
                    key: 'usageCount',
                    align: 'center',
                    sortable: 'custom'
                },
                {
                    title: '使用时长',
                    key: 'duration',
                    align: 'center',
                    sortable: 'custom'
                },
                {
                    title: '人均使用时长',
                    key: 'avgDuration',
                    align: 'center',
                    sortable: 'custom',
                    sortType: 'desc'
                }
            ]
        };
    },
    computed: {
        // 当前分页
        // 当前班级列表（服务端分页，直接返回列表）
        currentClassList() {
            return this.classDetailList;
        }
    },
    filters: {
        numberFormat(value) {
            return value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
        }
    },
    mounted() {
        // 获取学校统计数据
        this.fetchSchoolStatistic();

        // 获取Top10应用使用数据
        this.fetchAppUseTop();

        // 获取应用使用趋势数据
        this.fetchAppUseTrend();

        // 获取应用类型分布数据
        this.fetchAppUseDistribution();

        // 获取应用使用明细数据
        this.fetchAppUseDetail();

        // 获取班级使用明细数据
        this.fetchClassUseList();

        this.initCharts();
        //监听窗户大小变化
        window.addEventListener('resize', this.handleResize);
    },
    beforeDestroy() {
        window.removeEventListener('resize', this.handleResize);
        if (this.top10ChartInstance) this.top10ChartInstance.dispose();
        if (this.trendChartInstance) this.trendChartInstance.dispose();
        if (this.typeChartInstance) this.typeChartInstance.dispose();
    },
    watch: {
        top10TabActive() {
            this.updateTop10Chart();
        },
        trendTabActive() {
            this.updateTrendChart();
        },
        typeTabActive() {
            this.updateTypeChart();
        }
    },
    methods: {
        // 获取当天日期范围
        getTodayDateRange() {
            const today = new Date();
            const year = today.getFullYear();
            const month = String(today.getMonth() + 1).padStart(2, '0');
            const day = String(today.getDate()).padStart(2, '0');

            const startTime = `${year}-${month}-${day} 00:00:00`;
            const endTime = `${year}-${month}-${day} 23:59:59`;

            return { startTime, endTime };
        },

        // 获取学校统计数据
        async fetchSchoolStatistic() {
            try {
                // const { startTime, endTime } = this.getTodayDateRange();
                const params = {
                    schoolId: this.schoolId
                };

                const res = await getSchoolStatistic(params);
                if (res) {
                    // 更新总览数据
                    this.totalUsers = res.useUserNum || 0;
                    // 将小数转换为百分比
                    this.userPercentage = res.useRate ? `${res.useRate}%` : '0%';
                    this.totalUsages = res.operationCount || 0;
                    // 将秒转换为分钟
                    this.avgDuration = secondsToMinutes(res.yesterdayUseTimeAvg || 0, 0);
                }
            } catch (error) {
                console.error('获取学校统计数据失败:', error);
            }
        },

        // 获取Top10应用使用数据
        async fetchAppUseTop() {
            try {
                const params = {
                    schoolId: this.schoolId
                };
                const res = await getAppUseTop(params);
                if (res) {
                    this.top10Data = res || [];
                    // 更新图表
                    this.updateTop10Chart();
                }
            } catch (error) {
                console.error('获取Top10应用使用数据失败:', error);
            }
        },

        // 获取应用使用趋势数据
        async fetchAppUseTrend() {
            try {
                const params = {
                    schoolId: this.schoolId
                };
                const res = await getAppUseTrend(params);
                if (res) {
                    this.trendData = res || null;
                    // 更新图表
                    this.updateTrendChart();
                }
            } catch (error) {
                console.error('获取应用使用趋势数据失败:', error);
            }
        },

        // 获取应用类型分布数据
        async fetchAppUseDistribution() {
            try {
                const params = {
                    schoolId: this.schoolId
                };
                const res = await getAppUseDistribution(params);
                if (res) {
                    this.typeData = res || null;
                    // 更新图表
                    this.updateTypeChart();
                }
            } catch (error) {
                console.error('获取应用类型分布数据失败:', error);
            }
        },

        // 获取应用使用明细数据
        async fetchAppUseDetail() {
            try {
                const params = {
                    schoolId: this.schoolId,
                    sort: this.appDetailSort.sort,
                    order: this.appDetailSort.order
                };
                const res = await getAppUseDetail(params);
                if (res) {
                    // 处理数据，转换时间格式
                    this.appDetailList = (res || []).map(item => {
                        return {
                            appName: item.appName,
                            appType: item.moduleName,
                            moduleCode: item.moduleCode,
                            users: item.useUserNum || 0,
                            times: item.operationCount || 0,
                            duration: `${secondsToHours(item.operationTime || 0, 2)}h`,
                            avgDuration: `${secondsToHours(item.useAvgTime || 0, 2)}h`
                        };
                    });
                }
            } catch (error) {
                console.error('获取应用使用明细数据失败:', error);
            }
        },

        // 获取班级使用明细数据
        async fetchClassUseList() {
            try {
                const params = {
                    schoolId: this.schoolId,
                    page: this.pageParams.page,
                    limit: this.pageParams.limit,
                    sortType: this.classDetailSort.sortType,
                    order: this.classDetailSort.order
                };

                const res = await getClassUseList(params);
                if (res) {
                    // 更新分页信息
                    this.pageParams.total = res.total_rows || 0;
                    this.pageParams.pageCount = res.page_count || 0;

                    // 处理数据，转换时间格式
                    this.classDetailList = (res.rows || []).map(item => {
                        const useUserNum = item.useUserNum || 0;
                        const stuNum = item.stuNum || 0;
                        const operationTime = item.operationTime || 0;
                        const percentage = stuNum > 0 ? Math.round((useUserNum / stuNum) * 100) : 0;

                        // 计算人均使用时长
                        const avgTime = useUserNum > 0 ? operationTime / useUserNum : 0;

                        return {
                            className: `${item.gradeName || ''}${item.className || ''}`,
                            userCount: `${useUserNum}/${stuNum} (${percentage}%)`,
                            usageCount: item.operationCount || 0,
                            duration: `${secondsToHours(operationTime, 2)}h`,
                            avgDuration: `${secondsToHours(avgTime, 2)}h`
                        };
                    });
                }
            } catch (error) {
                console.error('获取班级使用明细数据失败:', error);
            }
        },

        // 初始化图表
        initCharts() {
            this.$nextTick(() => {
                this.initTop10Chart();
                this.initTrendChart();
                this.initTypeChart();
            });
        },

        // 初始化Top10应用使用情况柱状图
        initTop10Chart() {
            if (!this.$refs.top10Chart) return;
            this.top10ChartInstance = echarts.init(this.$refs.top10Chart);
            this.updateTop10Chart();
        },

        // 应用使用情况柱状图
        updateTop10Chart() {
            if (!this.top10ChartInstance) return;

            // 如果还没有数据，使用默认值
            if (!this.top10Data) {
                const option = {
                    grid: {
                        left: '80px',
                        right: '40px',
                        top: '20px',
                        bottom: '20px'
                    },
                    xAxis: {
                        type: 'value',
                        axisLine: { show: false },
                        axisTick: { show: false },
                        splitLine: {
                            show: false
                        },
                        axisLabel: {
                            color: '#666'
                        }
                    },
                    yAxis: {
                        type: 'category',
                        data: [],
                        axisLine: { show: false },
                        axisTick: { show: false },
                        axisLabel: {
                            color: '#333',
                            fontSize: 12
                        }
                    },
                    series: [{
                        type: 'bar',
                        data: [],
                        barWidth: 16,
                        showBackground: true,
                        backgroundStyle: {
                            color: '#F8F8FF'
                        },
                        itemStyle: {
                            color: '#5B8FF9',
                            borderRadius: [4, 4, 4, 4]
                        }
                    }]
                };
                this.top10ChartInstance.setOption(option);
                return;
            }

            // 根据选中的tab获取对应的数据
            let chartData = [];
            let appNames = [];

            if (this.top10TabActive === 'times') {
                // 使用时长
                chartData = this.top10Data.filter(
                    (item) => {
                        return item.type === 'operationTime'
                    }
                )[0];
            } else if (this.top10TabActive === 'users') {
                // 使用人数
                chartData = this.top10Data.filter(
                    (item) => {
                        return item.type === 'useUserNum'
                    }
                )[0];
            } else if (this.top10TabActive === 'nums') {
                // 使用次数
                chartData = this.top10Data.filter(
                    (item) => {
                        return item.type === 'operationCount'
                    }
                )[0];
            }
            // 提取应用名称和对应的值
            appNames = chartData.data.map((item, index) => `${index + 1} ${item.appName || ''}`).reverse();
            const values = chartData.data.map(item => {
                if (this.top10TabActive === 'times') {
                    // 使用时长从秒转换为小时，保留2位小数
                    return secondsToHours(item.data || 0, 2);
                } else if (this.top10TabActive === 'users') {
                    return item.data || 0;
                } else {
                    return item.data || 0;
                }
            }).reverse();

            // 根据选中的tab确定单位
            let unit = '';
            if (this.top10TabActive === 'times') {
                unit = '单位 (h)';
            } else if (this.top10TabActive === 'users') {
                unit = '单位 (人)';
            } else {
                unit = '单位 (次)';
            }

            const option = {
                tooltip: {
                    trigger: 'axis',
                    axisPointer: {
                        type: 'shadow'
                    },
                    formatter: (params) => {
                        const data = params[0];
                        let unit = '';
                        if (this.top10TabActive === 'times') {
                            unit = '小时';
                        } else if (this.top10TabActive === 'users') {
                            unit = '人';
                        } else {
                            unit = '次';
                        }
                        return `${data.name}<br/>${data.value}${unit}`;
                    }
                },
                grid: {
                    left: '120px',
                    right: '70px',
                    top: '20px',
                    bottom: '40px'
                },
                xAxis: {
                    type: 'value',
                    name: unit,
                    nameLocation: 'end',
                    nameGap: 5,
                    nameTextStyle: {
                        color: '#666',
                        fontSize: 12,
                        align: 'right',
                        padding: [25, -60, 0, 0]  // [上, 右, 下, 左] 调整位置：往下25px，往右20px
                    },
                    axisLine: { show: false },
                    axisTick: { show: false },
                    splitLine: {
                        show: false
                    },
                    axisLabel: {
                        color: '#666',
                        fontSize: 14,
                    }
                },
                yAxis: {
                    type: 'category',
                    data: appNames,
                    axisLine: { show: false },
                    axisTick: { show: false },
                    axisLabel: {
                        color: '#333',
                        fontSize: 14,
                        width: 100,
                        overflow: 'truncate',
                        formatter: (value) => {
                            // 提取序号和应用名称
                            const match = value.match(/^(\d+)\s+(.+)$/);
                            if (!match) return value;

                            const index = match[1];
                            const appName = match[2];

                            // 如果应用名称超过4个字，截取并添加省略号
                            const displayName = appName.length > 4 ? appName.substring(0, 4) + '...' : appName;
                            return `{index|${index}}.{name|${appName}}`;
                        },
                        rich: {
                            index: {
                                width: 15,
                                color: '#333',
                                fontSize: 14
                            },
                            name: {
                                color: '#333',
                                fontSize: 14
                            }
                        }
                    }
                },
                series: [{
                    type: 'bar',
                    data: values,
                    barWidth: 18,
                    showBackground: true,
                    backgroundStyle: {
                        color: '#F8F8FF'
                    },
                    itemStyle: {
                        color: '#1E5EFF',
                        borderRadius: [4, 4, 4, 4]
                    }
                }]
            };

            this.top10ChartInstance.setOption(option);
        },

        // 初始化应用使用趋势折线图
        initTrendChart() {
            if (!this.$refs.trendChart) return;
            this.trendChartInstance = echarts.init(this.$refs.trendChart);
            this.updateTrendChart();
        },

        // 应用使用趋势折线图
        updateTrendChart() {
            if (!this.trendChartInstance) return;

            // 如果还没有数据，显示空图表
            if (!this.trendData || !this.trendData.data || !this.trendData.dateList) {
                const option = {
                    grid: {
                        left: '50px',
                        right: '40px',
                        top: '20px',
                        bottom: '50px'
                    },
                    legend: {
                        data: [],
                        bottom: 0,
                        left: 'center',
                        icon: 'roundRect',
                        itemWidth: 26,
                        itemHeight: 12
                    },
                    xAxis: {
                        type: 'category',
                        data: [],
                        boundaryGap: false,
                        axisLine: {
                            lineStyle: { color: '#E8E8E8' }
                        },

                        axisTick: { show: false },
                        axisLabel: {
                            color: '#666',
                            fontSize: 14,
                        }
                    },
                    yAxis: {
                        type: 'value',
                        axisLine: { show: false },
                        axisTick: { show: false },
                        splitLine: {
                            lineStyle: { color: '#F0F0F0' }
                        },
                        axisLabel: {
                            color: '#666',
                            fontSize: 14,
                        }
                    },
                    series: []
                };
                this.trendChartInstance.setOption(option);
                return;
            }

            // 根据选中的tab获取对应的数据
            let trendTypeData = null;
            if (this.trendTabActive === 'times') {
                // 使用时长
                trendTypeData = this.trendData.data.find(item => item.type === 'operationTime');
            } else if (this.trendTabActive === 'users') {
                // 使用人数
                trendTypeData = this.trendData.data.find(item => item.type === 'useUserNum');
            } else if (this.trendTabActive === 'nums') {
                // 使用次数
                trendTypeData = this.trendData.data.find(item => item.type === 'operationCount');
            }

            if (!trendTypeData || !trendTypeData.data) {
                return;
            }

            // 定义颜色映射
            const colorMap = {
                '精准学': '#1E5EFF',
                'AI伴学': '#1FD286',
                '同步学': '#FFC700',
                '同步辅导': '#9D74FE'
            };

            // 构建系列数据
            const series = trendTypeData.data.map(module => {
                let data = module.data || [];

                // 如果是使用时长，转换为小时
                if (this.trendTabActive === 'times') {
                    data = data.map(seconds => secondsToHours(seconds || 0, 2));
                }

                return {
                    name: module.moduleName,
                    type: 'line',
                    data: data,
                    smooth: true,
                    symbol: 'circle',
                    symbolSize: 6,
                    lineStyle: {
                        color: colorMap[module.moduleName] || '#5B8FF9',
                        width: 2
                    },
                    itemStyle: {
                        color: colorMap[module.moduleName] || '#5B8FF9'
                    }
                };
            });

            // 提取图例数据
            const legendData = trendTypeData.data.map(module => module.moduleName);

            // 根据选中的tab确定单位
            let unit = '';
            let unitForTooltip = '';
            if (this.trendTabActive === 'times') {
                unit = '单位 (h)';
                unitForTooltip = '小时';
            } else if (this.trendTabActive === 'users') {
                unit = '单位 (人)';
                unitForTooltip = '人';
            } else {
                unit = '单位 (次)';
                unitForTooltip = '次';
            }

            const option = {
                tooltip: {
                    trigger: 'axis',
                    formatter: (params) => {
                        let result = params[0].axisValue + '<br/>';
                        params.forEach(item => {
                            result += `${item.marker}${item.seriesName}: ${item.value}${unitForTooltip}<br/>`;
                        });
                        return result;
                    }
                },
                grid: {
                    left: '50px',
                    right: '40px',
                    top: '40px',
                    bottom: '50px'
                },
                legend: {
                    data: legendData,
                    bottom: 0,
                    left: 'center',
                    icon: 'roundRect',
                    itemWidth: 26,
                    itemHeight: 12
                },
                xAxis: {
                    type: 'category',
                    data: this.trendData.dateList.map(date => {
                        // 去除年份，只保留月-日
                        return date.substring(5);
                    }),
                    boundaryGap: ['10%', '10%'],
                    axisLine: {
                        lineStyle: { color: '#E8E8E8' }
                    },
                    axisTick: { show: false },
                    axisLabel: {
                        color: '#666'
                    }
                },
                yAxis: {
                    type: 'value',
                    name: unit,
                    nameLocation: 'end',
                    nameGap: 20,
                    nameTextStyle: {
                        color: '#666',
                        fontSize: 12,
                        align: 'right',
                        padding: [0, 0, 0, 10]
                    },
                    axisLine: { show: false },
                    axisTick: { show: false },
                    splitLine: {
                        lineStyle: { color: '#F0F0F0' }
                    },
                    axisLabel: {
                        color: '#666'
                    }
                },
                series: series
            };

            this.trendChartInstance.setOption(option);
        },

        // 初始化应用类型图表
        initTypeChart() {
            if (!this.$refs.typeChart) return;
            this.typeChartInstance = echarts.init(this.$refs.typeChart);
            this.updateTypeChart();
        },

        // 应用类型饼状图
        updateTypeChart() {
            if (!this.typeChartInstance) return;

            // 如果还没有数据，显示空图表
            if (!this.typeData) {
                const option = {
                    legend: {
                        orient: 'horizontal',
                        bottom: 20,
                        left: 'center',
                        icon: 'roundRect',
                        itemWidth: 26,
                        itemHeight: 12,
                        data: []
                    },
                    series: [{
                        type: 'pie',
                        radius: ['40%', '65%'],
                        center: ['50%', '45%'],
                        avoidLabelOverlap: false,
                        label: {
                            show: true,
                            position: 'outside',
                            formatter: '{b}: {d}%',
                            fontSize: 12
                        },
                        labelLine: {
                            show: true,
                            length: 15,
                            length2: 10
                        },
                        data: []
                    }]
                };
                this.typeChartInstance.setOption(option);
                return;
            }

            // 根据选中的tab获取对应的数据
            let typeDistData = null;
            if (this.typeTabActive === 'times') {
                // 使用时长
                typeDistData = this.typeData.find(item => item.type === 'operationTime');
            } else if (this.typeTabActive === 'users') {
                // 使用人数
                typeDistData = this.typeData.find(item => item.type === 'useUserNum');
            } else if (this.typeTabActive === 'nums') {
                // 使用次数
                typeDistData = this.typeData.find(item => item.type === 'operationCount');
            }

            if (!typeDistData || !typeDistData.data) {
                return;
            }

            // 定义颜色映射
            const colorMap = {
                '精准学': '#1E5EFF',
                'AI伴学': '#1FD286',
                '同步学': '#FFC700',
                '同步辅导': '#9D74FE'
            };

            // 构建饼图数据
            const pieData = typeDistData.data.map(module => {
                let value = module.data || 0;

                // 如果是使用时长，转换为小时
                if (this.typeTabActive === 'times') {
                    value = secondsToHours(value, 2);
                }

                return {
                    value: value,
                    name: module.moduleName,
                    itemStyle: { color: colorMap[module.moduleName] || '#5B8FF9' }
                };
            });

            // 提取图例数据
            const legendData = typeDistData.data.map(module => module.moduleName);

            // 根据选中的tab确定单位
            let unitForTooltip = '';
            let unitShort = '';
            if (this.typeTabActive === 'times') {
                unitForTooltip = '小时';
                unitShort = 'h';
            } else if (this.typeTabActive === 'users') {
                unitForTooltip = '人';
                unitShort = '人';
            } else {
                unitForTooltip = '次';
                unitShort = '次';
            }

            const option = {
                tooltip: {
                    trigger: 'item',
                    formatter: (params) => {
                        return `${params.name}<br/>${params.marker}${params.value}${unitForTooltip} (${params.percent}%)`;
                    }
                },
                legend: {
                    orient: 'horizontal',
                    bottom: 20,
                    left: 'center',
                    icon: 'roundRect',
                    itemWidth: 26,
                    itemHeight: 12,
                    data: legendData
                },
                series: [{
                    type: 'pie',
                    radius: ['30%', '50%'],
                    center: ['50%', '45%'],
                    avoidLabelOverlap: false,
                    label: {
                        show: true,
                        position: 'outside',
                        formatter: (params) => {
                            return `${params.name}\n${params.value}${unitShort}（${params.percent}%）`;
                        },
                        fontSize: 14
                    },
                    labelLine: {
                        show: true,
                        length: 15,
                        length2: 10
                    },
                    data: pieData
                }]
            };

            this.typeChartInstance.setOption(option);
        },

        // 处理图标重置大小
        handleResize() {
            if (this.top10ChartInstance) this.top10ChartInstance.resize();
            if (this.trendChartInstance) this.trendChartInstance.resize();
            if (this.typeChartInstance) this.typeChartInstance.resize();
        },

        // 根据类型获取样式名称
        getAppTypeClass(type) {
            const typeMap = {
                'pb_jzx': 'type-blue',
                'pb_bx': 'type-green',
                'pb_tbx': 'type-yellow',
                'pb_tbfd': 'type-purple'
            };
            return typeMap[type] || '';
        },

        // 分页变化
        handleCurrentChange(page) {
            this.pageParams.page = page;
            // 重新获取数据
            this.fetchClassUseList();
        },

        // 应用使用明细排序
        handleAppSort(column) {
            const key = column.key;
            const order = column.order;

            // 字段映射关系
            const keyMap = {
                'users': 'useUserNum',
                'times': 'operationCount',
                'duration': 'operationTime',
                'avgDuration': 'useAvgTime'
            };

            if (order === 'normal') {
                // 恢复默认排序（按人均使用时长降序）
                this.appDetailSort.sort = 'useAvgTime';
                this.appDetailSort.order = 'desc';
            } else {
                // 更新排序参数
                this.appDetailSort.sort = keyMap[key] || 'useAvgTime';
                this.appDetailSort.order = order;
            }

            // 重新获取数据
            this.fetchAppUseDetail();
        },

        // 班级使用明细排序
        handleClassSort(column) {
            const key = column.key;
            const order = column.order;

            // 字段映射关系 (1:使用人数 2:使用次数 3:使用时长 4:人均使用时长)
            const keyMap = {
                'userCount': 1,
                'usageCount': 2,
                'duration': 3,
                'avgDuration': 4
            };

            if (order === 'normal') {
                // 恢复默认排序（按人均使用时长降序）
                this.classDetailSort.sortType = 4;
                this.classDetailSort.order = 'desc';
            } else {
                // 更新排序参数
                this.classDetailSort.sortType = keyMap[key] || 4;
                this.classDetailSort.order = order;
            }

            // 重置到第一页
            this.pageParams.page = 1;
            // 重新获取数据
            this.fetchClassUseList();
        }
    }
};
</script>

<style lang="scss" scoped>
@import "../../style/config";

.student-pad-container {
    min-height: 100vh;
    background: #F8FAFC;
    padding-bottom: 60px;
    // padding: 20px;

    .page-header {
        position: relative;
        background: #fff;
        height: 70px;
        display: flex;
        align-items: center;
        justify-content: center;
        margin-bottom: 20px;

        .title-icon {
            width: 52px;
            height: 26px;
            margin: 0 24px;
        }

        .page-title {
            font-size: 24px;
            font-weight: bold;
            color: #333;
        }

        .tip-content {
            position: absolute;
            right: vw(160);
            bottom: 8px;
            display: flex;
            align-items: center;

            i {
                width: 14.5px;
                height: 14.5px;
                background: url('../../assets/images/studentPad/tip-icon.png');
                background-size: 100% 100%;
                display: inline-block;
                margin-right: 6px;
            }

            span {
                font-size: 14px;
                color: #A9A9A9;
                letter-spacing: 1px;
            }
        }
    }

    .student-pad-main {
        padding: 0 vw(160);
    }

    // 汇总卡片
    .top-statistics {
        display: flex;
        gap: 20px;
        margin-bottom: 20px;

        .stat-card {
            flex: 1;
            background: #FFF;
            border-radius: 4px;
            padding: 28px 40px 12px 14px;
            position: relative;
            box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);

            .stat-card-border {
                position: absolute;
                left: 0;
                top: 0;
                bottom: 0;
                width: 14px;
                border-radius: 8px 0 0 8px;
            }

            .stat-card-content {
                display: flex;
                justify-content: space-between;
                // align-items: center;
                padding-left: 40px;
            }

            .stat-info {
                text-align: left;

                .stat-label {
                    font-size: 16px;
                    color: #333333;
                    margin-bottom: 5px;
                }

                .stat-value {
                    font-family: Microsoft YaHei, Microsoft YaHei;
                    font-weight: bold;
                    font-size: 24px;
                    color: #333333;
                    margin-bottom: 8px;
                }

                .stat-desc {
                    font-size: 14px;
                    color: #333333;
                }

                .stat-desc-val {
                    color: #1E5EFF;
                }
            }

            .stat-icon {
                width: 108px;
                height: 108px;
                display: flex;
                align-items: center;
                justify-content: center;

                img {
                    width: 100%;
                    height: 100%;
                }
            }

            &.stat-card-blue {
                .stat-card-border {
                    background: #5B8FF9;
                }
            }

            &.stat-card-green {
                .stat-card-border {
                    background: #5AD8A6;
                }
            }

            &.stat-card-yellow {
                .stat-card-border {
                    background: #F6BD16;
                }
            }
        }
    }

    .chart-row {
        display: flex;
        gap: 20px;
        margin-bottom: 20px;

        .chart-card {
            background: #FFF;
            box-shadow: 0px 2px 4px 0px rgba(0, 0, 0, 0.1);
            border-radius: 8px 8px 8px 8px;
            padding: 22px;

            &.chart-card-small {
                width: 35%;
            }

            &.chart-card-large {
                flex: 1;
            }

            &.chart-card-full {
                width: 100%;
            }

            .chart-header {
                display: flex;
                justify-content: space-between;
                align-items: center;
                margin-bottom: 15px;

                .chart-title {
                    display: flex;
                    align-items: center;
                    font-weight: bold;
                    font-size: 20px;
                    color: #333333;
                    white-space: nowrap;

                    .title-bar {
                        width: 4px;
                        height: 18px;
                        background: #5B8FF9;
                        margin-right: 12px;
                        flex-shrink: 0;
                    }

                    .sub-title {
                        font-size: 14px;
                        color: #666;
                        margin-left: 4px;
                        font-weight: 400;
                    }
                }

                .chart-tabs {
                    display: flex;
                    gap: 2px;
                    background: #F8F8FF;
                    border-radius: 8px 8px 8px 8px;
                    width: 240px;
                    height: 34px;
                    padding: 3px 4px;

                    .tab-btn {
                        padding: 3px 6px;
                        border: unset !important;
                        ;
                        background: unset !important;
                        color: #666;
                        cursor: pointer;
                        font-size: 16px;
                        transition: all 0.3s;


                        &:first-child {
                            border-radius: 4px 0 0 4px;
                        }

                        &:last-child {
                            border-radius: 0 4px 4px 0;
                            border-left: none;
                        }

                        &.active {
                            color: #FFF;
                            border-color: #5B8FF9;
                            background: rgba(30, 94, 255, 0.9) !important;
                            border-radius: 8px 8px 8px 8px;
                        }

                        &:hover:not(.active) {
                            background: #F5F5F5;
                        }
                    }
                }
            }

            .chart-content {
                width: 100%;
            }

            .table-content {

                // 自定义 iview Table 样式
                ::v-deep .ivu-table {
                    .ivu-table-cell {
                        padding-left: 0;
                        padding-right: 0;
                    }

                    th {
                        background: #F8F8FF !important;
                        height: 40px;
                        padding: 0 8px;
                        font-size: 14px;
                        font-weight: 600;
                        color: #333;
                        border-bottom: 1px solid #F0F0F0 !important;
                    }

                    // 排序图标样式
                    // .ivu-table-sort {
                    //     i {
                    //         font-size: 16px !important;
                    //     }

                    //     .ivu-icon-arrow-up-b,
                    //     .ivu-icon-arrow-down-b {
                    //         display: inline-block !important;
                    //     }
                    // }

                    td {
                        padding: 12px 7px;
                        font-size: 14px;
                        color: #333;
                        border-bottom: 1px solid #F0F0F0;
                    }

                    .ivu-table-row:hover td {
                        background: #FAFAFA !important;
                    }

                    tbody tr {
                        border-bottom: 1px solid #F0F0F0;
                    }

                    // 确保表格边框颜色一致
                    &.ivu-table-border {
                        border: 1px solid #F0F0F0;

                        td,
                        th {
                            border-right: 1px solid #F0F0F0;
                        }
                    }

                    thead tr th {
                        border-bottom: 1px solid #F0F0F0 !important;
                    }

                    // 设置表格底部线颜色
                    &:before {
                        background-color: #F0F0F0;
                    }
                }

                // 应用类型标签样式（使用深度选择器确保在动态表格中生效）
                ::v-deep .app-type-tag {
                    display: inline-block;
                    // padding: 2px 9px;
                    border-radius: 6px;
                    font-size: 14px;
                    width: 62px;
                    height: 24px;
                    line-height: 24px;
                    text-align: center;

                    &.type-blue {
                        background: #4A7DFE;
                        color: #fff;
                    }

                    &.type-green {
                        background: #4ADA9E;
                        color: #fff;
                    }

                    &.type-yellow {
                        background: #FED132;
                        color: #fff;
                    }

                    &.type-purple {
                        background: #9D74FE;
                        color: #fff;
                    }
                }

                .bottom-page {
                    margin-top: 20px;

                    .laypage_main {
                        display: flex;
                        justify-content: center;
                    }
                }

                &.app-detail-table {
                    height: 370px;
                    overflow-y: auto;

                    // 滚动条样式
                    &::-webkit-scrollbar {
                        width: 6px;
                    }

                    &::-webkit-scrollbar-thumb {
                        background: #ddd;
                        border-radius: 3px;
                    }

                    &::-webkit-scrollbar-thumb:hover {
                        background: #bbb;
                    }
                }
            }
        }
    }
}
</style>
